<div class="d-flex justify-content-between align-items-center"
  [ngStyle]="{'border-bottom':'2px solid black', 'margin-bottom':'10px'}">
  <h2 mat-dialog-title dialogTitle class="mar-b-5 pd-t-5px">VIEW MEETINGS</h2>
  <div class="d-flex align-items-center gap-3">
    <mat-icon (click)="closeDialog()" [ngStyle]="{'cursor':'pointer'}">close</mat-icon>
  </div>
</div>

<div contentContainer class="row">

<!-- <div *ngFor="let group of paginatedMeetings" class="meeting-group">
  <mat-card>
    <h3>{{ group.date }}</h3>
    <mat-divider></mat-divider>
    <ul>
      <li *ngFor="let meeting of group.meetings">
        <strong (click)="openMeeting(meeting)">{{ meeting.MEETING_TITLE }}</strong> ({{ meeting.FACILITATOR }})
      </li>
    </ul>
  </mat-card>
</div> -->

<adc-table [dataSource]="dataSource" (openLink)="openMeeting($event)" [noData]="noData" (searchEvent)="columnSearch($event)"></adc-table>
<adc-pagination [totalItems]="totalItems" [itemsPerPage]= "10" [itemsPerPageArr]="itemsPerPageArr" (pageChange)="pageChange($event)"
(itemsPerPageChange)="itemsPerPageChange($event)" [ngStyle]="{'margin-top':'4rem'}"></adc-pagination>
<!-- <mat-paginator [length]="groupedMeetings.length"
               [pageSize]="pageSize"
               [pageSizeOptions]="[2, 3, 5]"
               (page)="pageChanged($event)">
</mat-paginator> -->
</div>
